/* ADD FAVS */
export const ADD_FAV = "ADD_FAV"
export const ADD_FAV_SUCCESS = "ADD_FAV_SUCCESS"
export const ADD_FAV_CLEAN = "ADD_FAV_CLEAN"
export const ADD_FAV_ERROR = "ADD_FAV_ERROR"
